import { endOfDay, startOfDay } from 'date-fns';
import { useMemo } from 'react';
import { useToday } from 'shared/contexts/today';
import { useExternalCalendarEventsQuery } from 'shared/hooks/queries/use-external-calendar-events-query';

export const useTodayExternalCalendarEvents = () => {
  const today = useToday();
  const { data } = useExternalCalendarEventsQuery(
    startOfDay(today).toISOString(),
    endOfDay(today).toISOString(),
    Intl.DateTimeFormat().resolvedOptions().timeZone,
  );

  return useMemo(() => (data?.length ? data : []), [data]);
};
